import { H5, H6, LI, UL } from "../../../AbstractElements";
import { QuickAccessTitle } from "../../../Constant";
import { QUICK_ACCESS_DATA } from "../../../Data/FileManager";

const QuickAccess = () => {
  return (
    <>
      <H5>{QuickAccessTitle}</H5>
      <UL className='simple-list quick-file d-flex flex-row'>
        {QUICK_ACCESS_DATA.map((item, i) => (
          <LI key={i}>
            <div className='quick-box'>{item.icon}</div>
            <H6>{item.title}</H6>
          </LI>
        ))}
      </UL>
    </>
  );
};

export default QuickAccess;
